import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, User } from '@phosphor-icons/react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      login(response.data.access_token);
      toast.success('Login berhasil!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login gagal. Cek username dan password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-10">
          <img 
            src="https://xgrids.com/assets/logo_white.ceffc551.png" 
            alt="XGRIDS" 
            className="h-10 mx-auto mb-6"
          />
          <h1 className="font-heading text-2xl font-bold text-white mb-2" data-testid="admin-login-title">
            Admin Panel
          </h1>
          <p className="text-xgrids-text-secondary text-sm">
            Masuk untuk mengelola konten website
          </p>
        </div>

        <form 
          onSubmit={handleSubmit} 
          className="bg-xgrids-bg-surface border border-white/10 p-8 rounded-sm"
          data-testid="admin-login-form"
        >
          <div className="mb-6">
            <label className="block text-sm font-medium text-xgrids-text-secondary mb-2">Username</label>
            <div className="relative">
              <User size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-xgrids-text-muted" />
              <Input
                type="text"
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                required
                placeholder="admin"
                className="bg-xgrids-bg-primary border-white/10 text-white rounded-none pl-10"
                data-testid="admin-username-input"
              />
            </div>
          </div>

          <div className="mb-8">
            <label className="block text-sm font-medium text-xgrids-text-secondary mb-2">Password</label>
            <div className="relative">
              <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-xgrids-text-muted" />
              <Input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                placeholder="••••••••"
                className="bg-xgrids-bg-primary border-white/10 text-white rounded-none pl-10"
                data-testid="admin-password-input"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-xgrids-brand-primary text-xgrids-bg-primary hover:bg-xgrids-brand-hover rounded-none py-6 font-semibold"
            data-testid="admin-login-btn"
          >
            {loading ? 'Memproses...' : 'Masuk'}
          </Button>

          <p className="text-xgrids-text-muted text-xs text-center mt-6">
            Default: admin / xgrids2024
          </p>
        </form>
      </motion.div>
    </div>
  );
}
